/**
 * Hook de datos bancarios de ATSA (cuenta única BNA) — ADR #042
 *
 * Lee las claves `banco_*` de la tabla `parametros` (lectura permitida a todo
 * usuario autenticado por RLS). Si falta alguna clave obligatoria (CBU o
 * alias) devuelve null y la UI simplemente no muestra el bloque.
 */

import { useQuery } from '@tanstack/react-query';
import { supabase } from '../services/supabase';
import type { DatosBancarios } from '../types/datosBancarios';
import { parametrosToDatosBancarios } from '../types/datosBancarios';

const CLAVES_BANCO = [
  'banco_razon_social',
  'banco_cuit',
  'banco_nombre',
  'banco_cuenta',
  'banco_cbu',
  'banco_alias',
];

export function useDatosBancarios() {
  return useQuery({
    queryKey: ['datos-bancarios'] as const,
    queryFn: async (): Promise<DatosBancarios | null> => {
      const { data, error } = await supabase
        .from('parametros')
        .select('clave, valor')
        .in('clave', CLAVES_BANCO);
      if (error) throw error;
      return parametrosToDatosBancarios(Array.isArray(data) ? data : []);
    },
    staleTime: 5 * 60_000,
  });
}
